export const GET_REPORTS = 'GET_REPORTS';
export const GOT_REPORTS = 'GOT_REPORTS';
export const ERROR_GETTING_REPROTS = 'ERROR_GETTING_REPROTS';
export const UPDATE_SET_MIN_CON_DURATION_FORM = 'UPDATE_SET_MIN_CON_DURATION_FORM';
export const UPDATE_SET_MIN_MEETING_DURATION_FORM = 'UPDATE_SET_MIN_MEETING_DURATION_FORM';
export const UPDATE_MIN_DURATIONS = 'UPDATE_MIN_DURATIONS';
export const UPDATED_MIN_DURATIONS = 'UPDATED_MIN_DURATIONS';
export const RESET_MIN_DURATIONS = 'RESET_MIN_DURATIONS';
export const UPDATE_START_DATE_FOR_REPORTS = 'UPDATE_START_DATE_FOR_REPORTS';
export const UPDATE_END_DATE_FOR_REPORTS = 'UPDATE_END_DATE_FOR_REPORTS';
export const CHANGE_FETCHING_REPORTS = 'CHANGE_FETCHING_REPORTS';
export const HIDE_DATA_OUTDATE_WARNING = 'HIDE_DATA_OUTDATE_WARNING';

import { getAuthHeaders, setToken, logout, isUserOnLoginPage } from '../businessLogic/authorizator';
import fc from '../businessLogic/fetchInterceptor';
import { updateShowSetMinDurationsModal } from './modal';
import moment from 'moment';

export function updateReportSearch(
  minConDur = 0,
  minMeetingDur = 0,
  timezone,
  startDate = moment().utcOffset(timezone).startOf('month').format('YYYY-MM-DD'),
  endDate = moment().utcOffset(timezone).endOf('month').format('YYYY-MM-DD')
) {
  return (dispatch) => {
    dispatch({ type: GET_REPORTS });
    // When refresh the data, it need to hide the warning
    dispatch(hideDataOutOfDateWarning(true));
    // Call api
    let fetchReport = () => {
      fc.get(window.APP.CONFIGURATION.VCCAPI + `report/summary/${minConDur}/${minMeetingDur}/${startDate}/${endDate}`)
        .then((data) => {
          return dispatch({ type: GOT_REPORTS, data: data });
        })
        .catch((err) => {
          console.error('There was an error getting the report data', err.toString());
          dispatch({ type: ERROR_GETTING_REPROTS });
        });
    };
    fetchReport();
  };
}

export function hideDataOutOfDateWarning(hideOrNot) {
  return (dispatch) => {
    dispatch({ type: HIDE_DATA_OUTDATE_WARNING, data: hideOrNot });
  };
}

export function updateShowSetMinConDurationsForm(value) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SET_MIN_CON_DURATION_FORM, data: value });
  };
}

export function updateShowSetMinMeetingDurationsForm(value) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SET_MIN_MEETING_DURATION_FORM, data: value });
  };
}

export function updateStartDateForReporting(startDate) {
  return (dispatch) => {
    dispatch({ type: UPDATE_START_DATE_FOR_REPORTS, data: startDate });
    window.localStorage.setItem('startDateForReport', startDate);
  };
}

export function updateEndDateForReporting(endDate) {
  return (dispatch) => {
    dispatch({ type: UPDATE_END_DATE_FOR_REPORTS, data: endDate });
    window.localStorage.setItem('endDateForReport', endDate);
  };
}

export function updateMinDurationsValues(valueArray, reportsVars, userId, cb) {
  return (dispatch) => {
    dispatch({ type: UPDATE_MIN_DURATIONS, data: valueArray });
    dispatch({ type: GET_REPORTS });

    let minConsultationDur = valueArray[0] || 0;
    let minMeetingDur = valueArray[1] || 0;
    window.localStorage.setItem(`minConsultationDur-${userId}`, valueArray[0]);
    window.localStorage.setItem(`minMeetingDur-${userId}`, valueArray[1]);
    dispatch({ type: UPDATED_MIN_DURATIONS });
    if (cb) cb(false);
    // Only when having valid start date and end date will start to fetch
    if (reportsVars[0] != null && reportsVars[1] != null) {
      fc.get(
        window.APP.CONFIGURATION.VCCAPI +
          `report/summary/${minConsultationDur}/${minMeetingDur}/${reportsVars[0]}/${reportsVars[1]}`
      )
        .then((data) => {
          dispatch({ type: GOT_REPORTS, data: data });
        })
        .catch((err) => {
          console.error('There was an API error', err.toString());
          dispatch({ type: ERROR_GETTING_REPROTS });
        });
    } else {
      dispatch({ type: CHANGE_FETCHING_REPORTS, data: false });
    }
  };
}

export function resetMinMeetingDurationsForm(minConDur, minMeetingDur) {
  return (dispatch) => {
    dispatch({
      type: RESET_MIN_DURATIONS,
      data: {
        minConDur: minConDur,
        minMeetingDur: minMeetingDur,
      },
    });
  };
}

export function downloadCSVFile(url, cb) {
  fetch(url, { headers: getAuthHeaders(), method: 'GET' })
    .then((res) => {
      let filename = res.headers.get('aafilename');

      if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match('CriOS')) {
        res
          .blob()
          .then((blob) => {
            let fileReader = new FileReader();
            fileReader.onload = (e) => {
              // Only on Chrome IOS
              let a = document.createElement('a');
              a.onclick = () => {
                window.open(fileReader.result, '_blank');
              };
              a.click();
            };
            fileReader.readAsDataURL(blob);
          })
          .then(() => {
            if (cb) cb();
          });
      } else {
        res
          .text()
          .then((text) => {
            let csvData = new Blob([text], { type: 'text/csv' });
            let csvUrl = URL.createObjectURL(csvData);
            let link = document.createElement('a');
            link.setAttribute('href', csvUrl);
            link.setAttribute('download', filename.toString());

            link.click();
          })
          .then(() => {
            if (cb) cb();
          });
      }
    })
    .catch((err) => {
      if (cb) cb();
      console.error('There was an API error', err.toString());
    });
}
